var exports = {
  "xG": "ProjectSettingsCard__72pBux",
  "Cx": "withDivider__rAoxDT",
  "sb": "ProjectSettingsCardHeader__uflKz0",
  "JJ": "cardTitle__WOv3IJ",
  "L_": "cardDescription__pGpqYf",
  "Pn": "ProjectSettingsCardBody__qEjeDF",
};

module.exports = exports;
